import { render } from "./buyShortCode.vue?vue&type=template&id=73a14032&scoped=true"
import script from "./buyShortCode.vue?vue&type=script&lang=js"
export * from "./buyShortCode.vue?vue&type=script&lang=js"

import "./buyShortCode.vue?vue&type=style&index=0&id=73a14032&scoped=true&lang=css"

import exportComponent from "/var/www/shortcodeMarket/clientdashboard/dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73a14032"]])

export default __exports__